import {
  IPaymentRequisitionLine,
  IPaymentRequisitionStatus,
  PaymentRequisitionStatusEnum,
  IPaymentRequisitionSupplierAddress,
  IPaymentRequisitionSupplierContact,
  PaymentRequisitionApprovalState,
  IPaymentRequisitionSupplier,
  IPaymentRequisitionSupplierData,
  IPaymentRequisitionLineData,
  IPaymentRequisitionStatusData,
  IPaymentRequisitionAttachment,
  IPaymentRequisitionAttachmentData,
  IPaymentRequisitionApproval,
  IPaymentRequisitionApprovalData,
  IPaymentRequisition,
  IPaymentRequisitionData,
  IPaymentRequisitionSupplierAddressFieldError,
  IPaymentRequisitionSupplierAddressFieldErrorData,
  IPaymentRequisitionSupplierContactFieldError,
  IPaymentRequisitionSupplierContactFieldErrorData,
  IPaymentRequisitionSupplierFieldError,
  IPaymentRequisitionSupplierFieldErrorData,
  IPaymentRequisitionLineFieldError,
  IPaymentRequisitionLineFieldErrorData,
  IPaymentRequisitionFieldError,
  IPaymentRequisitionFieldErrorData,
  IPaymentRequisitionSupplierAddressData,
  IPaymentRequisitionSupplierContactData,
  PaymentRequisitionPaymentType,
  IPaymentRequisitionComment,
  IPaymentRequisitionCommentData
} from './paymentrequisition.types';

import {
  IDepartment,
  Department,
  ICurrency,
  Currency,
  GLAccount,
  IGLAccount,
  User,
  IUser,
  Country,
  ICountry,
  FieldErrors,
  IFieldErrors,
  IAttachmentData,
  IAttachment
} from '@/models';

import { MentionCommentMixin } from '../mention/mention';
import { AbstractAttachment } from '../attachment/attachment';

import moment from 'moment';

export class PaymentRequisitionSupplierAddress
  implements IPaymentRequisitionSupplierAddress {
  readonly id?: number;
  readonly country?: ICountry | string;

  readonly address1: string = '';
  readonly address2: string = '';
  readonly city: string = '';
  readonly region: string = '';
  readonly postal_code: string = '';

  constructor(data?: IPaymentRequisitionSupplierAddressData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.address1) {
        this.address1 = data.address1;
      }

      if (data.address2) {
        this.address2 = data.address2;
      }

      if (data.city) {
        this.city = data.city;
      }

      if (data.region) {
        this.region = data.region;
      }

      if (data.country) {
        this.country =
          typeof data.country === 'string'
            ? data.country
            : new Country(data.country);
      }

      if (data.postal_code) {
        this.postal_code = data.postal_code;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionSupplierContact
  implements IPaymentRequisitionSupplierContact {
  readonly id?: number;
  readonly name: string = '';
  readonly last_name: string = '';
  readonly email: string = '';
  readonly phone: string = '';

  constructor(data?: IPaymentRequisitionSupplierContactData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.name) {
        this.name = data.name;
      }

      if (data.email) {
        this.email = data.email;
      }

      if (data.phone) {
        this.phone = data.phone;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionSupplier implements IPaymentRequisitionSupplier {
  readonly id?: number;
  readonly name: string = '';
  readonly vendor_code: string = '';
  readonly address: IPaymentRequisitionSupplierAddress = new PaymentRequisitionSupplierAddress();
  readonly contact: IPaymentRequisitionSupplierContact = new PaymentRequisitionSupplierContact();

  constructor(data?: IPaymentRequisitionSupplierData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.name) {
        this.name = data.name;
      }

      if (data.vendor_code) {
        this.vendor_code = data.vendor_code;
      }

      if (data.address) {
        this.address = new PaymentRequisitionSupplierAddress(data.address);
      }

      if (data.contact) {
        this.contact = new PaymentRequisitionSupplierContact(data.contact);
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionLine implements IPaymentRequisitionLine {
  readonly id?: number;
  readonly item: string = '';
  readonly description: string = '';
  readonly total_price: number = 0;
  readonly account: IGLAccount | number | null = null;
  readonly department: IDepartment | number | null = null;

  constructor(data?: IPaymentRequisitionLineData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.account) {
        this.account =
          typeof data.account === 'number'
            ? data.account
            : new GLAccount(data.account);
      }

      if (data.department) {
        this.department =
          typeof data.department === 'number'
            ? data.department
            : new Department(data.department);
      }

      this.item = data.item;
      this.description = data.description;

      if (data.total_price) {
        this.total_price = data.total_price;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionStatus implements IPaymentRequisitionStatus {
  readonly value: number = PaymentRequisitionStatusEnum.Draft;
  readonly display_name: string = 'Draft';

  constructor(data?: IPaymentRequisitionStatusData) {
    if (data) {
      this.value = data.value;
      this.display_name = data.display_name;
    }
  }

  getIcon() {
    switch (this.value) {
      case PaymentRequisitionStatusEnum.Draft:
        return 'mdi-file-document-outline';

      case PaymentRequisitionStatusEnum.Submitted:
        return 'mdi-file-send-outline';

      case PaymentRequisitionStatusEnum.InReview:
        return 'mdi-file-send-outline';

      case PaymentRequisitionStatusEnum.Approval2Pending:
        return 'mdi-file-send-outline';

      case PaymentRequisitionStatusEnum.Approved:
        return 'mdi-file-send-outline';

      case PaymentRequisitionStatusEnum.Rejected:
        return 'mdi-file-send-outline';

      case PaymentRequisitionStatusEnum.Cancelled:
        return 'mdi-alert-circle';

      case PaymentRequisitionStatusEnum.Paid:
        return 'mdi-checkbox-marked-circle-outline';

      case PaymentRequisitionStatusEnum.APSpecialistAssigned:
      default:
        return 'mdi-file-document-outline';
    }
  }

  // Returns color based on state
  getColor(): string {
    switch (this.value) {
      case PaymentRequisitionStatusEnum.Draft:
        return 'draft';

      case PaymentRequisitionStatusEnum.Submitted:
      case PaymentRequisitionStatusEnum.InReview:
      case PaymentRequisitionStatusEnum.Approval2Pending:
        return 'submitted';

      case PaymentRequisitionStatusEnum.Approved:
        return 'approved';

      case PaymentRequisitionStatusEnum.APSpecialistAssigned:
        return 'blue';

      case PaymentRequisitionStatusEnum.Rejected:
        return 'reject';

      case PaymentRequisitionStatusEnum.Cancelled:
        return 'cancel';

      case PaymentRequisitionStatusEnum.Paid:
        return 'done';

      default:
        return 'white';
    }
  }

  static getStateList(): IPaymentRequisitionStatus[] {
    return [
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Draft,
        display_name: 'Draft'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Submitted,
        display_name: 'Submitted'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.InReview,
        display_name: 'Approval I Pending'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Approval2Pending,
        display_name: 'Approval II Pending'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Approved,
        display_name: 'Approved'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.APSpecialistAssigned,
        display_name: 'A/P Specialist Assigned'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Rejected,
        display_name: 'Rejected'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Cancelled,
        display_name: 'Cancelled'
      }),
      new PaymentRequisitionStatus({
        value: PaymentRequisitionStatusEnum.Paid,
        display_name: 'Paid'
      })
    ];
  }

  static getStatusFromState(state: PaymentRequisitionStatusEnum) {
    return PaymentRequisitionStatus.getStateList().find(
      status => state === status.value
    );
  }

  static getStatusMessageFromState(state: PaymentRequisitionStatusEnum) {
    return (
      PaymentRequisitionStatus.getStatusFromState(state)?.display_name ?? ' - '
    );
  }
}

export class PaymentRequisitionAttachment
  implements IPaymentRequisitionAttachment {
  readonly id?: number | undefined;
  readonly file: string | File;
  readonly filename: string = '';

  constructor(data: IPaymentRequisitionAttachmentData) {
    if (data.id) {
      this.id = data.id;
    }

    if (data.filename) {
      this.filename = data.filename;
    }

    this.file = data.file;
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionApproval implements IPaymentRequisitionApproval {
  readonly id?: number;
  readonly approver: IUser;
  readonly status: PaymentRequisitionApprovalState;
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  constructor(data: IPaymentRequisitionApprovalData) {
    if (data.id) {
      this.id = data.id;
    }
    this.approver = new User(data.approver);

    this.status = data.status ?? PaymentRequisitionApprovalState.TENTATIVE;

    if (data.created_at) {
      this.created_at = data.created_at;
    }

    if (data.updated_at) {
      this.updated_at = data.updated_at;
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }
}

export class PaymentRequisitionCommentAttachment extends AbstractAttachment {
  constructor(data: IAttachmentData) {
    super(data);
  }

  toString(): string {
    return this.filename;
  }
}

export class PaymentRequisitionComment extends MentionCommentMixin
  implements IPaymentRequisitionComment {
  readonly id?: number;
  readonly owner?: string;
  readonly text: string = '';
  readonly attachments: IAttachment[] = [];
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  constructor(data?: IPaymentRequisitionCommentData) {
    super(data);
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      if (data.owner) {
        this.owner = data.owner;
      }

      this.text = data.text ?? '';

      if (data.attachments) {
        this.attachments = data.attachments.map(
          attachment => new PaymentRequisitionCommentAttachment(attachment)
        );
      }

      if (data.created_at) {
        this.created_at = data.created_at;
      }

      if (data.updated_at) {
        this.updated_at = data.updated_at;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  get isCommentEdited(): boolean {
    //milliseconds is different for both fields
    return (
      moment(this.created_at).format('YYYY-MM-DDTHH:mm:ss') !==
      moment(this.updated_at).format('YYYY-MM-DDTHH:mm:ss')
    );
  }
}

export class PaymentRequisition implements IPaymentRequisition {
  readonly id?: number;
  readonly amount: number = 0;
  readonly num_items: number = 0;
  readonly payment?: PaymentRequisitionPaymentType;
  readonly po_number?: string;
  readonly reason?: string;
  readonly note?: string;
  readonly is_urgent?: boolean;
  readonly is_provide_payment_detail?: boolean;
  readonly status: IPaymentRequisitionStatus = new PaymentRequisitionStatus();
  readonly currency?: ICurrency | number;
  readonly attachments: IPaymentRequisitionAttachment[] = [];
  readonly lines: IPaymentRequisitionLine[] = [];
  readonly supplier: IPaymentRequisitionSupplier = new PaymentRequisitionSupplier();
  readonly required_date?: Date | string;
  readonly created_at?: Date | string;
  readonly updated_at?: Date | string;

  readonly approvers: PaymentRequisitionApproval[] = [];
  readonly ap_specialist?: IUser | number;
  readonly owner?: IUser | number;

  constructor(data?: IPaymentRequisitionData) {
    if (data) {
      if (data.id) {
        this.id = data.id;
      }

      // Need to check for undefined so that a value of zero would be treated
      // as a valid number
      if (typeof data.amount === 'number') {
        this.amount = data.amount;
      }

      if (typeof data.num_items == 'number') {
        this.num_items = data.num_items;
      }

      if (typeof data.payment == 'number') {
        this.payment = data.payment;
      }

      if (data.po_number) {
        this.po_number = data.po_number;
      }

      if (data.owner) {
        this.owner =
          typeof data.owner === 'number' ? data.owner : new User(data.owner);
      }

      if (data.reason) {
        this.reason = data.reason;
      }

      if (data.note) {
        this.note = data.note;
      }

      if (data.approvers) {
        this.approvers = data.approvers.map(
          approver => new PaymentRequisitionApproval(approver)
        );
      }

      if (data.ap_specialist) {
        this.ap_specialist =
          typeof data.ap_specialist === 'number'
            ? data.ap_specialist
            : new User(data.ap_specialist);
      }

      if (data.status) {
        this.status = new PaymentRequisitionStatus(data.status);
      }

      if (data.currency) {
        this.currency =
          typeof data.currency === 'number'
            ? data.currency
            : new Currency(data.currency);
      }

      if (data.lines) {
        this.lines = data.lines.map(line => new PaymentRequisitionLine(line));
      }

      if (data.attachments) {
        this.attachments = data.attachments.map(
          attachment => new PaymentRequisitionAttachment(attachment)
        );
      }

      if (data.supplier) {
        this.supplier = new PaymentRequisitionSupplier(data.supplier);
      }

      this.is_urgent = data.is_urgent ?? false;
      this.is_provide_payment_detail = data.is_provide_payment_detail ?? false;

      if (data.required_date) {
        this.required_date = data.required_date;
      }

      if (data.created_at) {
        this.created_at = data.created_at;
      }

      if (data.updated_at) {
        this.updated_at = data.updated_at;
      }
    }
  }

  validate(): boolean {
    throw new Error('Method not implemented.');
  }

  addLine(line: IPaymentRequisitionLine): void {
    this.lines.push(line);
  }

  removeLine(index: number): void {
    this.lines.splice(index, 1);
  }

  attachFile(file: File): void {
    this.attachments.push(new PaymentRequisitionAttachment({ file: file }));
  }

  detachFile(file: string | File): void {
    const index = this.attachments?.findIndex(
      attachment => attachment.file == file
    );

    if (index > -1) {
      this.attachments?.splice(index, 1);
    }
  }

  // ## Transition Permissions and Conditions ##
  /**
   * If user can approve requisition and transition from
   * from - [PaymentRequisitionStatusEnum.Submitted, PaymentRequisitionStatusEnum.InReview];
   * to - [PaymentRequisitionStatusEnum.Approved]
   */
  isUserApprover(userId: number): boolean {
    return this.approvers.some(
      approver => userId === (approver.approver as IUser).id
    );
  }

  /**
   * If user is the AP specialist; since only the assigned ap speclist can confirm payment
   */
  isUserApSpecialist(userId: number): boolean {
    return Boolean(
      this.ap_specialist && (this.ap_specialist as IUser).id === userId
    );
  }
}

export class PaymentRequisitionSupplierAddressFieldError
  implements IPaymentRequisitionSupplierAddressFieldError {
  readonly address1: string[] = [];
  readonly address2: string[] = [];
  readonly city: string[] = [];
  readonly region: string[] = [];
  readonly country: string[] = [];
  readonly postal_code: string[] = [];

  constructor(data?: IPaymentRequisitionSupplierAddressFieldErrorData) {
    if (data) {
      if (data.address1) {
        this.address1 = data.address1;
      }

      if (data.address2) {
        this.address2 = data.address2;
      }

      if (data.city) {
        this.city = data.city;
      }

      if (data.region) {
        this.region = data.region;
      }

      if (data.country) {
        this.country = data.country;
      }

      if (data.postal_code) {
        this.postal_code = data.postal_code;
      }
    }
  }

  clearErrors(): void {
    this.address1.splice(0, this.address1.length);
    this.address2.splice(0, this.address2.length);
    this.city.splice(0, this.city.length);
    this.region.splice(0, this.region.length);
    this.country.splice(0, this.country.length);
    this.postal_code.splice(0, this.postal_code.length);
  }
}

export class PaymentRequisitionSupplierContactFieldError
  implements IPaymentRequisitionSupplierContactFieldError {
  readonly name: string[] = [];
  readonly email: string[] = [];
  readonly phone: string[] = [];

  constructor(data?: IPaymentRequisitionSupplierContactFieldErrorData) {
    if (data) {
      if (data.name) {
        this.name = data.name;
      }

      if (data.email) {
        this.email = data.email;
      }

      if (data.phone) {
        this.phone = data.phone;
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
    this.email.splice(0, this.email.length);
    this.phone.splice(0, this.phone.length);
  }
}

export class PaymentRequisitionSupplierFieldError
  implements IPaymentRequisitionSupplierFieldError {
  readonly name: string[] = [];
  readonly vendor_code: string[] = [];
  readonly address: IPaymentRequisitionSupplierAddressFieldError = new PaymentRequisitionSupplierAddressFieldError();
  readonly contact: IPaymentRequisitionSupplierContactFieldError = new PaymentRequisitionSupplierContactFieldError();

  constructor(data?: IPaymentRequisitionSupplierFieldErrorData) {
    if (data) {
      if (data.name) {
        this.name = data.name;
      }

      if (data.vendor_code) {
        this.vendor_code = data.vendor_code;
      }

      if (data.address) {
        this.address = new PaymentRequisitionSupplierAddressFieldError(
          data.address
        );
      }

      if (data.contact) {
        if (Array.isArray(data.contact)) {
          // incase the servers returns the contat as an array only
          // HACK: we enforce what the display shows is jkust the fields inside are all errors
          // all mandatory
          this.contact = new PaymentRequisitionSupplierContactFieldError({
            name: data.contact
          });
        } else {
          this.contact = new PaymentRequisitionSupplierContactFieldError(
            data.contact
          );
        }
      }
    }
  }

  clearErrors(): void {
    this.name.splice(0, this.name.length);
    this.vendor_code.splice(0, this.vendor_code.length);
    this.address.clearErrors();
    this.contact.clearErrors();
  }
}

export class PaymentRequisitionLineFieldError
  implements IPaymentRequisitionLineFieldError {
  readonly item: string[] = [];
  readonly description: string[] = [];
  readonly quantity: string[] = [];
  readonly unit_price: string[] = [];
  readonly account: string[] = [];
  readonly department: string[] = [];

  constructor(data?: IPaymentRequisitionLineFieldErrorData) {
    if (data) {
      if (data.item) {
        this.item = data.item;
      }

      if (data.description) {
        this.description = data.description;
      }

      if (data.quantity) {
        this.quantity = data.quantity;
      }

      if (data.unit_price) {
        this.unit_price = data.unit_price;
      }

      if (data.account) {
        this.account = data.account;
      }

      if (data.department) {
        this.department = data.department;
      }
    }
  }

  clearErrors(): void {
    this.item.splice(0, this.item.length);
    this.description.splice(0, this.description.length);
    this.quantity.splice(0, this.quantity.length);
    this.unit_price.splice(0, this.unit_price.length);
    this.account.splice(0, this.account.length);
    this.department.splice(0, this.department.length);
  }

  static isPaymentRequisitionLineFieldError(
    data: IPaymentRequisitionLineFieldErrorData
  ): boolean {
    if (data) {
      if (data.item && Array.isArray(data.item)) {
        return true;
      } else if (data.description && Array.isArray(data.description)) {
        return true;
      } else if (data.quantity && Array.isArray(data.quantity)) {
        return true;
      } else if (data.unit_price && Array.isArray(data.unit_price)) {
        return true;
      } else if (data.account && Array.isArray(data.account)) {
        return true;
      } else if (data.department && Array.isArray(data.department)) {
        return true;
      }
    }

    return false;
  }
}

export class PaymentRequisitionFieldError
  implements IPaymentRequisitionFieldError {
  readonly currency: string[] = [];
  readonly reason: string[] = [];
  readonly project: string[] = [];
  readonly payment: string[] = [];
  readonly required_date: string[] = [];
  readonly po_number: string[] = [];
  readonly is_urgent: string[] = [];
  readonly attachments: IFieldErrors[] = [];
  readonly note: string[] = [];
  readonly supplier: IPaymentRequisitionSupplierFieldError = new PaymentRequisitionSupplierFieldError();
  readonly lines: IPaymentRequisitionLineFieldError[] = [];

  constructor(data?: IPaymentRequisitionFieldErrorData) {
    if (data) {
      if (data.currency) {
        this.currency = data.currency;
      }

      if (data.reason) {
        this.reason = data.reason;
      }

      if (data.required_date) {
        this.required_date = data.required_date;
      }

      if (data.po_number) {
        this.po_number = data.po_number;
      }

      if (data.is_urgent) {
        this.is_urgent = data.is_urgent;
      }

      if (data.attachments) {
        this.attachments = data.attachments.map(
          attachment => new FieldErrors(attachment)
        );
      }

      if (data.note) {
        this.note = data.note;
      }

      if (data.payment) {
        this.payment = data.payment;
      }

      if (data.supplier) {
        if (Array.isArray(data.supplier)) {
          // incase the servers returns the contat as an array only
          // HACK: we enforce what the display shows is jkust the fields inside are all errors
          // all mandatory
          this.supplier = new PaymentRequisitionSupplierFieldError({
            name: data.supplier,
            contact: new PaymentRequisitionSupplierContactFieldError({
              name: data.supplier
            })
          });
        } else {
          this.supplier = new PaymentRequisitionSupplierFieldError(
            data.supplier
          );
        }
      }

      if (data.lines) {
        this.lines = data.lines.map(
          line => new PaymentRequisitionLineFieldError(line)
        );
      }
    }
  }

  clearErrors(): void {
    this.currency.splice(0, this.currency.length);
    this.project.splice(0, this.project.length);
    this.reason.splice(0, this.reason.length);
    this.required_date.splice(0, this.required_date.length);
    this.po_number.splice(0, this.po_number.length);
    this.is_urgent.splice(0, this.is_urgent.length);
    this.note.splice(0, this.note.length);
    this.attachments.splice(0, this.attachments.length);
    this.payment.splice(0, this.payment.length);
    this.lines.splice(0, this.lines.length);
    this.supplier.clearErrors();
  }

  static isPaymentRequisitionFieldError(
    data: IPaymentRequisitionFieldErrorData
  ): boolean {
    if (data.currency && Array.isArray(data.currency)) {
      return true;
    } else if (data.reason && Array.isArray(data.reason)) {
      return true;
    } else if (data.required_date && Array.isArray(data.required_date)) {
      return true;
    } else if (data.po_number && Array.isArray(data.po_number)) {
      return true;
    } else if (data.is_urgent && Array.isArray(data.is_urgent)) {
      return true;
    } else if (data.note && Array.isArray(data.note)) {
      return true;
    } else if (data.attachments && Array.isArray(data.attachments)) {
      return true;
    } else if (data.payment && Array.isArray(data.payment)) {
      return true;
    } else if (data.lines && Array.isArray(data.lines)) {
      return true;
    } else if (data.supplier) {
      return true;
    }

    return false;
  }
}
